// These values need to match the response from https://qa8.metadata.ascendon.tv/Codes/Type/390/Language/en-US/SystemId/85788485-e411-48a9-b478-610c1285dc1a
export var BILL_ADJUSTMENT = '1001';
export var MISC_ADJUSTMENT = '1002';
export var DEPOSIT_ADJUSTMENT = '1003';
export var WRITEOFF_ADJUSTMENT = '5';
export var WRITEOFF_REVERSAL_ADJUSTMENT = '1007';
export var AR_TRANSFER_ADJUSTMENT_EXTERNAL_REFERENCE = 'AR_TRANSFER';
export var DEPOSIT_TRANSFER = '1001';
export var DEPOSIT_UPDATED = '1019';
export var ADJUSTMENT_CATEGORIES = {
  FINANCE: 'FINANCE',
  OTHER: 'OTHER'
};
export var ADJUSTMENT_PAYMENT_TYPES = {
  CREDIT: '0',
  DEBIT: '1'
};